import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AUTHGWCONSTANTS } from '../../authorization/authconstatnts';

@Injectable({
  providedIn: 'root'
})

export class LocationSetDialogService {

  public static dialogResult = false;
  headers: any;

  constructor(private http: HttpClient) {
    const xenAuth = localStorage.getItem(AUTHGWCONSTANTS.xenAuth);
    this.headers = { 'XEN-AUTHORIZATION': xenAuth };
    this.headers = { ...this.headers, ...environment.platformInfo };
  }

  getAddress(): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/resource/address/v3', {
      headers: this.headers,
    });
  }

  postAddress(body: any): Observable<any> {
    return this.http.post<any>(environment.proxyApiUrl + '/api/resource/address/v3', body, {
      headers: this.headers,
    });
  }

  putAddress(body: any): Observable<any> {
    return this.http.put<any>(environment.proxyApiUrl + '/api/resource/address/v3', body, {
      headers: this.headers,
    });
  }

  deletAddress(addressId: string): Observable<any> {
    return this.http.delete<any>(environment.proxyApiUrl + '/api/resource/address/v3', {
      headers: this.headers,
      params: { id: addressId },
    });
  }

  getServiceArea(urlParams: any): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl +
      '/api/service/area/selection', {
      headers: this.headers,
      params: urlParams
    });
  }
}

